module.exports = __webpack_public_path__ + "static/gallery-1-a0887fee81a727542589b6d57a97eb49.jpg";